<!--  -->
<template>
  <div class="re_box">
    <el-card class="box-card">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="item">
          <el-input v-model="query.name" style="width: 300px;" placeholder="配置名称" />
        </div>
        <div class="item">
          <el-input v-model="query.keyword" style="width: 300px;" placeholder="公众号app_id/链接id" />
        </div>
        <div class="item">
          <el-select v-model="query.status" placeholder="请选择状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="item">
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button size="mini" type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
          <el-button size="mini" type="success" icon="el-icon-s-help" @click="creater">创建</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        max-height="500"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
        />
        <el-table-column
          prop="name"
          label="规则名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="is_open_text"
          label="回传开关"
          width="180"
          align="center"
        />
        <el-table-column
          prop="report_recharge_type_text"
          label="配置内容"
          width="300"
          align="center"
        />
        <el-table-column
          prop="agents_phone"
          label="扣量比例"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.filtration_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="is_report_vip_amount_text"
          label="上报vip充值金额"
          width="180"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          width="100"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        />
        <el-table-column
          label="绑定的公众号/链接"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-for="item,index in scope.row.bind_list.app_ids" :key="index" type="success">{{ item }}</el-tag><br>
            <el-tag v-for="item,index in scope.row.bind_list.promotion_ids" :key="index">{{ item }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
          width="300px"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="editLink(scope.row)">设置公众号/链接</el-button>
            <el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="bandwechat(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        :title="'广告回传配置'"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="60%"
        :append-to-body="true"
      >
        <returndialog ref="returndialogview" @updata="updata" />
      </el-dialog>
      <el-dialog
        :title="'修改公众号/链接'"
        :visible.sync="editLinkVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="60%"
      >
        <el-input
          v-model="app_ids_text"
          type="textarea"
          :rows="3"
          placeholder="请输入公众号，输入多个请用英文逗号隔开"
          @blur="appIdBlur"
        />
        <div style="margin: 20px 0;" />
        <el-input
          v-model="promotion_ids_text"
          type="textarea"
          :rows="3"
          placeholder="请输入链接，输入多个请用英文逗号隔开"
          @blur="proMoIdBlur"
        />
        <div style="margin-top: 10px" />
        <el-button
          type="primary"
          @click="editAppIdsLink()"
        >提交</el-button>
        <el-button
          type="info"
          @click="editLinkVisible = false"
        >取消</el-button>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { backRuleAdminlist, backRuleAdmindelete, editAppIdsLink } from '@/api/returnPolicyList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import returndialog from './components/returndialog.vue'
export default {
  components: { PaginationRight, returndialog },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        name: '',
        status: '',
        created_at: '',
        keyword: ''
      },
      tableData: [],
      total: null,
      dialogVisible: false,
      options: [
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '下架'
        }
      ],
      editLinkVisible: false,
      app_ids_text: null,
      promotion_ids_text: null,
      edit_app_ids: [],
      edit_proIds_ids: []
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      const data = await backRuleAdminlist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
    },
    search() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.name = ''
      this.query.status = ''
      this.query.created_at = ''
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },

    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    creater() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.returndialogview.send(1)
      })
    },
    updata() {
      this.dialogVisible = false
      this.list()
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.returndialogview.send(2, item)
      })
    },
    bandwechat(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        backRuleAdmindelete({
          id: id
        }).then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
          this.list()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    editLink(val) {
      this.app_ids_text = ''
      this.promotion_ids_text = ''
      if (val.bind_list.app_ids) {
        const edit_app_ids = val.bind_list.app_ids
        this.app_ids_text = edit_app_ids.join(',')
      }
      if (val.bind_list.promotion_ids) {
        const edit_proIds_ids = val.bind_list.promotion_ids
        this.promotion_ids_text = edit_proIds_ids.join(',')
      }
      this.edit_id = val.id
      this.editLinkVisible = true
    },
    proMoIdBlur() {
      if (this.promotion_ids_text) {
        this.promotion_ids_text = this.promotion_ids_text.replace(/\n/g, ',')
      }
    },
    appIdBlur() {
      if (this.app_ids_text.length) {
        this.app_ids_text = this.app_ids_text.replace(/\n/g, ',')
      }
    },
    editAppIdsLink() {
      const appIdsArray = this.app_ids_text.split(',')
      const proIdsArray = this.promotion_ids_text.split(',')
      editAppIdsLink({
        app_ids: appIdsArray,
        promotion_ids: proIdsArray,
        id: this.edit_id
      }).then((res) => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 0) {
          this.$message.success('请求成功,请稍后刷新')
          this.editLinkVisible = false
          this.list()
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.re_box{
  padding: 30px;
}
.channelManagement{
margin: 30px;
width: 95%;
margin: 0 auto;
}
.el-card{
  margin-top:20px
}
.selectionArea {
  display: flex;
  /* flex-wrap: wrap; */
  /* justify-content: space-between; */
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
       display: inline-block;
       margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
</style>
